import * as React from "react";

function SvgAdQuick(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 290 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <path
        d="M272.818 123.407c20.826-30.777 17.609-72.953-9.651-100.193C247.722 7.77 227.461.02 207.2.038c-19.038 0-38.057 6.81-53.107 20.449.696.903 1.411 1.768 2.088 2.69a94.69 94.69 0 0113.075 25.133 48.017 48.017 0 013.348-3.744c9.538-9.556 22.067-14.335 34.578-14.335 12.51 0 25.039 4.779 34.577 14.335 15.37 15.37 18.361 38.414 9.011 56.793-8.616-8.616-22.613-8.616-31.229 0l-5.775 5.775 50.699 50.68a7.462 7.462 0 0010.554 0l16.104-16.103-18.305-18.304z"
        fill="#4A90E2"
      />
      <path
        d="M211.734 127.808c-13.977 1.298-28.407-3.367-39.111-14.071-9.425-9.425-14.203-21.69-14.335-34.03v-1.11c-.113-17.176-5.7-33.053-15.106-45.958C128.79 12.849 105.463 0 79.144 0 35.443 0 0 35.442 0 79.16c0 43.682 35.443 79.142 79.144 79.142v-.019c20.43 0 39.036-7.769 53.07-20.467a93.583 93.583 0 01-2.069-2.728 94.862 94.862 0 01-13.075-25.114c-8.974 11.024-22.613 18.097-37.945 18.097v.019-.019c-26.996 0-48.912-21.897-48.912-48.91 0-27.014 21.916-48.93 48.912-48.93 27.015 0 48.931 21.897 48.931 48.93 0 16.347 5.042 32.676 15.107 46.503 2.389 3.31 5.098 6.452 8.07 9.443 23.064 23.082 56.814 28.876 85.296 17.514l-24.795-24.813z"
        fill="#44AC6B"
      />
    </svg>
  );
}

export default React.forwardRef(SvgAdQuick);
